<template>
  <div id="app">
    <div class="header-spacer" :class="{ 'with-ad': showAd && advertisementList.length > 0 }"></div>
    <el-container>
      <el-header class="modern-header">
        <!-- 广告横幅区域 -->
        <div class="ad-banner" v-if="showAd && advertisementList.length > 0" @mouseenter="pauseScroll" @mouseleave="resumeScroll">
          <div class="ad-scroll-container" ref="scrollContainer">
            <div class="ad-scroll-wrapper" :style="{ marginTop: `-${currentIndex * itemHeight}px` }">
              <div 
                class="ad-item" 
                v-for="(ad, index) in advertisementList" 
                :key="ad.id"
                :ref="`adItem${index}`"
                @click="goToAdUrl(ad)">
                <div class="ad-content">
                  <img :src="ad.logo_image" :alt="ad.name">
                  <div class="ad-text">
                    <i class="el-icon-star-on"></i>
                    <span>{{ ad.name }}</span>
                  </div>
                  <div class="ad-type" v-if="ad.type">
                    <span>{{ ad.type }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ad-close" @click.stop="closeAd">
            <i class="el-icon-close"></i>
          </div>
        </div>
        
        <div class="header-content">
          <div class="head-left">
            <router-link to="/" class="logo-link">
              <div class="logo-text">
                <h1>众包网</h1>
                <p class="site-subtitle">找服务商，上众包网</p>
              </div>
            </router-link>
          </div>

          <div class="head-right">
            <p v-if="!isMobile" class="navigation-tip">众包导航·常看常新·收藏本站·Ctrl+D!</p>
            <div class="header-actions">
              <router-link to="/about" class="header-enter-btn">
                <i class="el-icon-s-promotion"></i>
                收录申请
              </router-link>
              <div class="stats-group">
                <span class="stats-item">
                  <i class="el-icon-check"></i> 已收录 <strong>{{ webTotal }}</strong> 家平台
                </span>
                <span class="stats-divider">|</span>
                <span class="stats-item">
                  <i class="el-icon-view"></i> 第 <strong>{{ visits }}</strong> 位访客
                </span>
              </div>
            </div>
          </div>
        </div>
      </el-header>
      
      <el-main class="modern-main">
        <router-view />
      </el-main>

      <el-footer class="modern-footer">
        <div class="footer-content">
          <div class="footer-section">
            <div class="footer-links">
              <p class="section-title">其他链接</p>
              <div class="link-group">
                <a href="https://www.gov.cn/" target="_blank">中国政府网</a>
                <a href="https://www.miit.gov.cn/" target="_blank">工业和信息化部</a>
                <a href="https://www.ccopyright.com.cn/" target="_blank">中国版权保护中心</a>
              </div>
            </div>
            
            <div class="footer-actions">
              <div class="action-card" v-for="action in footerActions" :key="action.name">
                <!-- 广告合作 -->
                <div v-if="action.modal" @click="openAdCooperationModal" class="action-link" style="cursor:pointer;">
                  <div class="action-icon">
                    <img :src="action.icon" :alt="action.name">
                  </div>
                  <span>{{ action.name }}</span>
                </div>
                <!-- 认领 -->
                <div v-else-if="action.claimModal" @click="openClaimModal" class="action-link" style="cursor:pointer;">
                  <div class="action-icon">
                    <img :src="action.icon" :alt="action.name">
                  </div>
                  <span>{{ action.name }}</span>
                </div>
                <!-- 热门推荐 -->
                <div v-else-if="action.hotModal" @click="openHotModal" class="action-link" style="cursor:pointer;">
                  <div class="action-icon">
                    <img :src="action.icon" :alt="action.name">
                  </div>
                  <span>{{ action.name }}</span>
                </div>
                <!-- 普通路由跳转 -->
                <router-link v-else-if="action.route" :to="action.route" class="action-link">
                  <div class="action-icon">
                    <img :src="action.icon" :alt="action.name">
                  </div>
                  <span>{{ action.name }}</span>
                </router-link>
              </div>
            </div>
          </div>
          
          <div class="footer-bottom">
            <div class="footer-trust">
              <span class="trust-item">
                <i class="el-icon-check"></i> 已服务 <strong>{{ webTotal }}</strong> 家平台
              </span>
              <span class="trust-item">
                <i class="el-icon-time"></i> 7×24小时服务
              </span>
              <span class="trust-item">
                <i class="el-icon-shield"></i> 数据安全保障
              </span>
            </div>
            <p class="copyright">
              Copyright © 2026 
              <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">
                蜀ICP备2021027962号-5
              </a>
            </p>
            <div class="police-badge">
              <img :src="policeIcon" class="police-icon" />
              <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51010802033117" target="_blank" rel="noopener noreferrer">
                川公网安备51010802033117号
              </a>
            </div>
          </div>
        </div>
      </el-footer>
    </el-container>

    <!-- ===== 右侧固定悬浮按钮：提交需求（上方） ===== -->
    <div class="floating-requirement-btn" @click="openRequirementModal">
      <div class="floating-icon">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M7 10L12 15L17 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M12 15V3" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <span class="floating-text">提交需求</span>
    </div>

    <!-- ===== 右侧固定悬浮按钮：我要接单（下方） ===== -->
    <div class="floating-order-btn" @click="openOrderModal">
      <div class="floating-icon">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2C13.3132 2 14.6136 2.25866 15.8268 2.7612C17.0401 3.26375 18.1425 4.00035 19.0711 4.92893C19.9997 5.85752 20.7362 6.95991 21.2388 8.17317C21.7413 9.38642 22 10.6868 22 12" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M12 16L12 2" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M12 22C16.4183 22 20 18.4183 20 14" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M8 14L12 18L16 14" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <span class="floating-text">我要接单</span>
    </div>

    <!-- ===== 认领弹窗 ===== -->
    <div v-if="showClaimModal" class="modal-overlay" @click.self="closeClaimModal">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">📋 认领</h3>
          <button class="modal-close" @click="closeClaimModal">×</button>
        </div>
        <p class="modal-desc">认领您的企业或服务，让更多客户找到您</p>
        <div class="claim-benefit">
          <span class="benefit-icon">🎁</span>
          <span class="benefit-text">认领审核成功后，将赠送 <strong>1个月</strong> 的「热门推荐」</span>
        </div>
        
        <form class="modal-form" @submit.prevent="submitClaim">
          <div class="form-group">
            <label>手机号码 <span class="required">*</span></label>
            <input 
              v-model="claimForm.userName" 
              type="tel" 
              placeholder="请输入手机号码" 
              maxlength="11"
              class="form-input"
              @input="validateClaimPhone"
              required
            >
          </div>
          
          <div class="form-row">
            <div class="form-group">
              <label>图形验证码 <span class="required">*</span></label>
              <div class="captcha-input-group">
                <input 
                  v-model="claimForm.captchaInput" 
                  type="text" 
                  placeholder="请输入验证码" 
                  maxlength="4"
                  class="form-input"
                  required
                >
                <div 
                  class="captcha-image" 
                  @click="refreshClaimCaptcha"
                  v-html="claimCaptchaImage"
                  title="点击刷新"
                ></div>
              </div>
            </div>
            <div class="form-group">
              <label>短信验证码 <span class="required">*</span></label>
              <div class="code-input-group">
                <input 
                  v-model="claimForm.userCode" 
                  type="text" 
                  placeholder="请输入验证码" 
                  maxlength="4"
                  class="form-input code-input"
                  required
                >
                <button 
                  type="button" 
                  class="code-btn" 
                  :disabled="claimCodeCountdown > 0 || !claimForm.userName"
                  @click="handleClaimSendCode"
                >
                  {{ claimCodeCountdown > 0 ? `${claimCodeCountdown}秒后重发` : '发送验证码' }}
                </button>
              </div>
            </div>
          </div>
          
          <div class="form-row">
            <div class="form-group">
              <label>公司名称 <span class="required">*</span></label>
              <input 
                v-model="claimForm.companyName" 
                type="text" 
                placeholder="请输入公司名称" 
                class="form-input"
                required
              >
            </div>
            <div class="form-group">
              <label>网站名称 <span class="required">*</span></label>
              <div class="input-with-action">
                <div class="input-container">
                  <input 
                    v-model="claimForm.productName" 
                    type="text" 
                    placeholder="请输入网站名称" 
                    class="form-input"
                    required
                  >
                </div>
                <button 
                  type="button" 
                  class="check-btn"
                  @click="checkProductName"
                  :disabled="!claimForm.productName || claimNameChecking"
                >
                  <i class="el-icon-search"></i>
                  {{ claimNameChecking ? '查询中...' : '查询名称' }}
                </button>
              </div>
              <div v-if="claimNameCheckResult !== null" class="name-check-result" :class="claimNameCheckResult ? 'success' : 'error'">
                <i :class="claimNameCheckResult ? 'el-icon-success' : 'el-icon-error'"></i>
                {{ claimNameCheckResult ? '✓ 名称已收录，可继续认领' : '✗ 名称不存在，请先提交收录申请' }}
              </div>
            </div>
          </div>
          
          <div class="form-row">
            <div class="form-group">
              <label>姓名 <span class="required">*</span></label>
              <input 
                v-model="claimForm.contactName" 
                type="text" 
                placeholder="请输入您的姓名" 
                class="form-input"
                required
              >
            </div>
            <div class="form-group">
              <label>职务</label>
              <input 
                v-model="claimForm.position" 
                type="text" 
                placeholder="请输入您的职务" 
                class="form-input"
              >
            </div>
          </div>
          
          <div class="form-submit">
            <button type="submit" class="submit-btn" :disabled="!claimNameCheckResult">
              提交认领
            </button>
          </div>
        </form>
      </div>
    </div>

    <!-- ===== 提交需求弹窗 ===== -->
    <div v-if="showRequirementModal" class="modal-overlay" @click.self="closeRequirementModal">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">📝 提交需求</h3>
          <button class="modal-close" @click="closeRequirementModal">×</button>
        </div>
        <p class="modal-desc">提交您的需求，我们将为您匹配最合适的服务商</p>
        
        <!-- 平台微信引导 -->
        <div class="platform-wechat-guide">
          <div class="guide-icon">💬</div>
          <div class="guide-content">
            <span class="guide-title">添加平台微信，获取更快速的服务匹配</span>
            <div class="guide-wechat">
              <span class="guide-label">微信号：</span>
              <span class="guide-number" @click="copyWechat">331277651</span>
              <button class="guide-copy-btn" @click="copyWechat">
                <i class="el-icon-document-copy"></i> 复制
              </button>
            </div>
          </div>
        </div>

        <form class="modal-form" @submit.prevent="submitRequirement">
          <div class="form-group">
            <label>手机号码 <span class="required">*</span></label>
            <input 
              v-model="reqForm.userName" 
              type="tel" 
              placeholder="请输入手机号码" 
              maxlength="11"
              class="form-input"
              @input="validateReqPhone"
              required
            >
          </div>
          
          <div class="form-row">
            <div class="form-group">
              <label>图形验证码 <span class="required">*</span></label>
              <div class="captcha-input-group">
                <input 
                  v-model="reqForm.captchaInput" 
                  type="text" 
                  placeholder="请输入验证码" 
                  maxlength="4"
                  class="form-input"
                  required
                >
                <div 
                  class="captcha-image" 
                  @click="refreshReqCaptcha"
                  v-html="reqCaptchaImage"
                  title="点击刷新"
                ></div>
              </div>
            </div>
            <div class="form-group">
              <label>短信验证码 <span class="required">*</span></label>
              <div class="code-input-group">
                <input 
                  v-model="reqForm.userCode" 
                  type="text" 
                  placeholder="请输入验证码" 
                  maxlength="4"
                  class="form-input code-input"
                  required
                >
                <button 
                  type="button" 
                  class="code-btn" 
                  :disabled="reqCodeCountdown > 0 || !reqForm.userName"
                  @click="handleReqSendCode"
                >
                  {{ reqCodeCountdown > 0 ? `${reqCodeCountdown}秒后重发` : '发送验证码' }}
                </button>
              </div>
            </div>
          </div>
          
          <div class="form-row">
            <div class="form-group">
              <label>联系人 <span class="required">*</span></label>
              <input 
                v-model="reqForm.lx_userName" 
                type="text" 
                placeholder="请输入联系人姓名" 
                maxlength="20"
                class="form-input"
                required
              >
            </div>
            <div class="form-group">
              <label>所在城市 <span class="required">*</span></label>
              <input 
                v-model="reqForm.address" 
                type="text" 
                placeholder="请输入所在城市" 
                maxlength="20"
                class="form-input"
                required
              >
            </div>
          </div>
          
          <div class="form-row">
            <div class="form-group">
              <label>服务分类 <span class="required">*</span></label>
              <select v-model="reqForm.fw_name" class="form-input" required>
                <option value="" disabled selected>请选择服务分类</option>
                <option v-for="service in serviceOptions" :key="service" :value="service">
                  {{ service }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label>项目预算 <span class="required">*</span></label>
              <input 
                v-model="reqForm.ys_money" 
                type="text" 
                placeholder="请输入项目预算" 
                maxlength="20"
                class="form-input"
                required
              >
            </div>
          </div>
          
          <div class="form-group">
            <label>具体需求描述 <span class="required">*</span></label>
            <textarea
              v-model="reqForm.notes"
              placeholder="请详细描述您的需求，包括功能、时间等"
              maxlength="500"
              class="form-input textarea"
              required
            ></textarea>
            <div class="char-count">{{ reqForm.notes.length }}/500</div>
          </div>
          
          <div class="form-submit">
            <button type="submit" class="submit-btn">提交需求</button>
          </div>
        </form>
      </div>
    </div>

    <!-- ===== 广告合作弹窗 ===== -->
    <div v-if="showAdCooperationModal" class="modal-overlay" @click.self="closeAdCooperationModal">
      <div class="modal-content ad-cooperation-content">
        <div class="modal-header">
          <h3 class="modal-title">📢 广告合作</h3>
          <button class="modal-close" @click="closeAdCooperationModal">×</button>
        </div>
        <div class="ad-cooperation-body">
          <div class="ad-cooperation-icon">
            <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="#F58019" stroke="#F58019" stroke-width="2" stroke-linejoin="round"/>
            </svg>
          </div>
          <h4 class="ad-cooperation-title">欢迎洽谈广告合作</h4>
          <p class="ad-cooperation-desc">
            众包网拥有精准的流量和优质的用户群体，<br>
            期待与您携手共创价值！
          </p>
          <a 
            href="https://work.weixin.qq.com/kfid/kfc34b34d72125d3151"
            target="_blank"
            rel="noopener noreferrer"
            class="ad-cooperation-btn"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.691 2.188C4.891 2.188 1.5 4.883 1.5 8.53c0 2.067 1.01 3.771 2.575 5.013l-.605 1.677 1.822-.919c.651.229 1.349.383 2.106.403l.001-.001c.307.044.621.077.941.099l.089-1.034c-2.061-.192-3.761-1.034-4.715-2.281l-.003-.003c-.337-.505-.59-1.096-.59-1.994 0-2.969 2.775-5.157 5.993-5.157 2.977 0 5.442 1.843 5.903 4.236l1.045-.135c.533-.069 1.069-.104 1.593-.104l.193.003c-.557-3.119-3.649-5.445-6.63-5.445z" fill="white"/>
              <path d="M15.26 10.157c-.56 0-1.013.453-1.013 1.012s.453 1.013 1.013 1.013 1.012-.454 1.012-1.013-.453-1.012-1.012-1.012zm4.108 0c-.56 0-1.013.453-1.013 1.012s.453 1.013 1.013 1.013c.56 0 1.012-.454 1.012-1.013s-.453-1.012-1.012-1.012zm-9.444 2.18c-3.596 0-6.513-2.463-6.513-5.498s2.917-5.498 6.513-5.498c3.595 0 6.512 2.463 6.512 5.498 0 3.035-2.917 5.498-6.512 5.498zm8.452 1.478c-1.602 0-3.051-.586-4.151-1.543 2.102-.376 3.843-1.724 4.151-3.434l.398-.063c.599-.094 1.213-.144 1.844-.144l.276.002c-.368-2.543-2.947-4.419-5.707-4.419-3.447 0-6.239 2.387-6.239 5.33 0 2.943 2.792 5.33 6.239 5.33.443 0 .876-.043 1.302-.121l1.313.532-.392-1.092c.982-.558 1.706-1.343 2.066-2.293l.001.001z" fill="white"/>
            </svg>
            立即联系在线客服
          </a>
          <p class="ad-cooperation-tip">点击按钮即可与企业微信客服沟通</p>
        </div>
      </div>
    </div>

    <!-- ===== 热门推荐弹窗 ===== -->
    <div v-if="showHotModal" class="modal-overlay" @click.self="closeHotModal">
      <div class="modal-content hot-modal">
        <div class="modal-header">
          <h3 class="modal-title">🔥 热门推荐</h3>
          <button class="modal-close" @click="closeHotModal">×</button>
        </div>
        <div class="hot-body">
          <div class="hot-icon">🚀</div>
          <h4 class="hot-title">让您的平台获得更多曝光</h4>
          <div class="hot-features">
            <div class="hot-feature">
              <span class="hot-feature-icon">📍</span>
              <div>
                <strong>首页置顶推荐</strong>
                <p>在首页显著位置展示您的平台</p>
              </div>
            </div>
            <div class="hot-feature">
              <span class="hot-feature-icon">🎯</span>
              <div>
                <strong>精准流量导入</strong>
                <p>定向推送给目标用户群体</p>
              </div>
            </div>
            <div class="hot-feature">
              <span class="hot-feature-icon">📊</span>
              <div>
                <strong>数据统计分析</strong>
                <p>提供详细的访问数据报告</p>
              </div>
            </div>
          </div>
          <a 
            href="https://work.weixin.qq.com/kfid/kfc34b34d72125d3151"
            target="_blank"
            rel="noopener noreferrer"
            class="hot-contact-btn"
          >
            立即咨询合作
          </a>
          <p class="hot-tip">点击按钮联系客服，获取详细方案</p>
        </div>
      </div>
    </div>

    <!-- ===== 我要接单弹窗 ===== -->
    <div v-if="showOrderModal" class="modal-overlay" @click.self="closeOrderModal">
      <div class="modal-content order-modal">
        <div class="modal-header">
          <h3 class="modal-title">📋 我要接单</h3>
          <button class="modal-close" @click="closeOrderModal">×</button>
        </div>
        <div class="order-body">
          <div class="order-icon">💼</div>
          <h4 class="order-title">成为接单服务商</h4>
          <p class="order-desc">
            无论您是 <strong>个人</strong> 还是 <strong>企业</strong>，<br>
            添加平台微信，获取更多订单推荐机会！
          </p>
          <div class="order-wechat">
            <div class="wechat-label">
              <i class="el-icon-mobile-phone"></i>
              平台微信号
            </div>
            <div class="wechat-number" @click="copyWechat">
              <span>331277651</span>
              <button class="copy-btn">
                <i class="el-icon-document-copy"></i> 复制
              </button>
            </div>
            <p class="wechat-tip">👆 点击微信号或复制按钮，打开微信添加好友</p>
          </div>
          <div class="order-remark">
            <p class="remark-title">📌 添加时请按以下格式备注：</p>
            <div class="remark-item personal">
              <span class="remark-tag">个人</span>
              <span class="remark-example">姓名 + 擅长领域</span>
              <span class="remark-demo">例如：张三 + 前端开发</span>
            </div>
            <div class="remark-item enterprise">
              <span class="remark-tag">企业</span>
              <span class="remark-example">公司名称 + 擅长领域</span>
              <span class="remark-demo">例如：XX科技 + 软件开发</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { webNum, getGgLb, recordAd, getCaptcha, verifyCaptcha, getPhoneCode, webYuyueService, submitClaim, slyz } from './api/all'
import policeIcon from './assets/police.png'

export default {
  name: 'HomeView',
  data() {
    return {
      isMobile: null,
      webTotal: 0,
      visits: 0,
      advertisementList: [],
      showAd: true,
      currentIndex: 0,
      scrollTimer: null,
      isPaused: false,
      itemHeight: 52,
      policeIcon: policeIcon,
      isAdLoaded: false,
      
      // 底部菜单
      footerActions: [
        { name: '收录申请', route: '/about', icon: '/home/slsq.png' },
        { name: '认领', claimModal: true, icon: '/home/claim.png' },
        { name: '留言反馈', route: '/jyly', icon: '/home/jyly.png' },
        { name: '广告合作', modal: true, icon: '/home/ad.png' },
        { name: '热门推荐', hotModal: true, icon: '/home/hot.png' }
      ],
      
      serviceOptions: [
        '创业创投',
        '项目招标',
        '常用工具',
        '交流资讯',
        '广告推广',
        '兼职工作',
        '工程维修',
        '数据标注',
        '人力外包',
        '家政服务',
        '硬件设备',
        '快递配送',
        '知识产权',
        '软件开发',
        '绘画设计',
        '企服财税',
        '其它服务'
      ],
      
      showClaimModal: false,
      showRequirementModal: false,
      showAdCooperationModal: false,
      showHotModal: false,
      showOrderModal: false,
      
      claimForm: {
        userName: '',
        captchaInput: '',
        userCode: '',
        companyName: '',
        productName: '',
        contactName: '',
        position: ''
      },
      claimCaptchaKey: '',
      claimCaptchaImage: '',
      claimCaptchaToken: '',
      claimCodeCountdown: 0,
      claimNameCheckResult: null,
      claimNameChecking: false,
      
      reqForm: {
        userName: '',
        captchaInput: '',
        userCode: '',
        lx_userName: '',
        address: '',
        ys_money: '',
        fw_name: '',
        notes: ''
      },
      reqCaptchaKey: '',
      reqCaptchaImage: '',
      reqCaptchaToken: '',
      reqCodeCountdown: 0
    }
  },
  async mounted() {
    // 先注册事件监听
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
    
    // ===== 方式1：通过 $root 事件总线监听统计数据 =====
    this.$root.$on('updateStats', this.updateStats)
    
    // ===== 方式2：从 $root 读取已有数据（如果 HomeView 先执行了） =====
    if (this.$root._statsData) {
      this.webTotal = this.$root._statsData.webTotal || 0
      this.visits = this.$root._statsData.visits || 0
    }
    
    // 监听 HomeView 数据加载完成事件，只加载一次广告
    this.$root.$on('homeDataLoaded', async () => {
      if (!this.isAdLoaded && this.advertisementList.length === 0) {
        this.isAdLoaded = true
        await this.getAdvertisement()
      }
    })
    
    // 备用方案：如果 3 秒后 homeDataLoaded 事件没有触发，也加载广告
    setTimeout(async () => {
      if (!this.isAdLoaded && this.advertisementList.length === 0) {
        this.isAdLoaded = true
        await this.getAdvertisement()
      }
    }, 3000)
    
    // 每隔 1 秒尝试从 $root 读取统计数据（兜底方案）
    this._statsInterval = setInterval(() => {
      if (this.webTotal === 0 && this.visits === 0 && this.$root._statsData) {
        this.webTotal = this.$root._statsData.webTotal || 0
        this.visits = this.$root._statsData.visits || 0
      }
      // 如果已经有数据了，停止轮询
      if (this.webTotal > 0 || this.visits > 0) {
        clearInterval(this._statsInterval)
        this._statsInterval = null
      }
    }, 1000)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile)
    this.stopScroll()
    this.$root.$off('updateStats', this.updateStats)
    this.$root.$off('homeDataLoaded')
    if (this._statsInterval) {
      clearInterval(this._statsInterval)
      this._statsInterval = null
    }
  },
  methods: {
    // ===== 接收 HomeView 传递的统计数据 =====
    updateStats(data) {
      if (data) {
        this.webTotal = data.webTotal || 0
        this.visits = data.visits || 0
      }
    },
    
    // ========== 弹窗控制 ==========
    openClaimModal() {
      this.showClaimModal = true
      this.claimNameCheckResult = null
      this.claimNameChecking = false
      this.$nextTick(() => {
        this.fetchClaimCaptcha()
      })
    },
    closeClaimModal() {
      this.showClaimModal = false
      this.claimForm.captchaInput = ''
      this.claimCodeCountdown = 0
      this.claimNameCheckResult = null
      this.claimNameChecking = false
    },
    openRequirementModal() {
      this.showRequirementModal = true
      this.$nextTick(() => {
        this.fetchReqCaptcha()
      })
    },
    closeRequirementModal() {
      this.showRequirementModal = false
      this.reqForm.captchaInput = ''
      this.reqCodeCountdown = 0
    },
    openAdCooperationModal() {
      this.showAdCooperationModal = true
    },
    closeAdCooperationModal() {
      this.showAdCooperationModal = false
    },
    openHotModal() {
      this.showHotModal = true
    },
    closeHotModal() {
      this.showHotModal = false
    },
    openOrderModal() {
      this.showOrderModal = true
    },
    closeOrderModal() {
      this.showOrderModal = false
    },
    
    // ========== 复制微信号 ==========
    copyWechat() {
      const wechat = '331277651'
      if (navigator.clipboard) {
        navigator.clipboard.writeText(wechat).then(() => {
          this.$message.success('微信号已复制，请打开微信添加好友')
        }).catch(() => {
          this.fallbackCopy(wechat)
        })
      } else {
        this.fallbackCopy(wechat)
      }
    },
    fallbackCopy(text) {
      const input = document.createElement('input')
      input.value = text
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$message.success('微信号已复制，请打开微信添加好友')
    },
    
    // ========== 网站名称查询 ==========
    async checkProductName() {
      const name = this.claimForm.productName
      if (!name) {
        this.$message.error('请输入网站名称')
        return
      }
      if (name.length < 2) {
        this.$message.error('网站名称至少2个字符')
        return
      }
      
      this.claimNameChecking = true
      try {
        const res = await slyz({ name: name })
        if (res.status === 1) {
          this.claimNameCheckResult = false
          this.$message.error('✗ 该产品尚未收录，请先提交收录申请')
        } else {
          this.claimNameCheckResult = true
          this.$message.success('✓ 名称已收录，可继续认领')
        }
      } catch (error) {
        this.$message.error('查询失败，请重试')
        this.claimNameCheckResult = null
      } finally {
        this.claimNameChecking = false
      }
    },
    
    // ========== 获取广告 ==========
    async getAdvertisement() {
      if (this.isAdLoaded && this.advertisementList.length > 0) return
      
      try {
        const res = await getGgLb()
        if (res && res.status === 1 && res.data && res.data.length > 0) {
          const validAds = res.data.filter(ad => ad.logo_image && ad.network_addr)
          this.advertisementList = validAds
          
          if (this.advertisementList.length > 1) {
            this.$nextTick(() => {
              this.updateItemHeight()
              this.startScroll()
            })
          }
        }
      } catch (error) {
        console.error('获取广告失败:', error)
      }
    },
    
    updateItemHeight() {
      if (this.$refs.adItem0 && this.$refs.adItem0[0]) {
        const height = this.$refs.adItem0[0].offsetHeight
        if (height > 0) {
          this.itemHeight = height
          if (this.$refs.scrollContainer) {
            this.$refs.scrollContainer.style.height = `${this.itemHeight}px`
          }
        }
      }
    },
    goToAdUrl(ad) {
      if (ad && ad.network_addr) {
        this.recordAdClick(ad.name)
        window.open(ad.network_addr, '_blank')
      }
    },
    async recordAdClick(name) {
      try {
        await recordAd({ name: name })
      } catch (error) {
        console.error('记录广告点击失败:', error)
      }
    },
    closeAd() {
      this.showAd = false
      this.stopScroll()
    },
    startScroll() {
      this.stopScroll()
      if (this.advertisementList.length <= 1) return
      
      this.scrollTimer = setInterval(() => {
        if (!this.isPaused && this.advertisementList.length > 1) {
          let nextIndex = this.currentIndex + 1
          if (nextIndex >= this.advertisementList.length) {
            nextIndex = 0
          }
          this.currentIndex = nextIndex
        }
      }, 3000)
    },
    stopScroll() {
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer)
        this.scrollTimer = null
      }
    },
    pauseScroll() {
      this.isPaused = true
    },
    resumeScroll() {
      this.isPaused = false
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 768
      if (this.isMobile) {
        this.itemHeight = 44
      } else {
        this.itemHeight = 52
      }
      this.updateItemHeight()
    },
    validateClaimPhone() {
      this.claimForm.userName = this.claimForm.userName.replace(/[^\d]/g, '')
    },
    validateReqPhone() {
      this.reqForm.userName = this.reqForm.userName.replace(/[^\d]/g, '')
    },
    
    // ========== 图形验证码 ==========
    async fetchClaimCaptcha() {
      try {
        const res = await getCaptcha()
        if (res.status === 1) {
          this.claimCaptchaImage = res.data.captcha
          this.claimCaptchaKey = res.data.captcha_id
          this.claimForm.captchaInput = ''
        }
      } catch (error) {
        console.error('获取认领验证码失败:', error)
      }
    },
    async fetchReqCaptcha() {
      try {
        const res = await getCaptcha()
        if (res.status === 1) {
          this.reqCaptchaImage = res.data.captcha
          this.reqCaptchaKey = res.data.captcha_id
          this.reqForm.captchaInput = ''
        }
      } catch (error) {
        console.error('获取需求验证码失败:', error)
      }
    },
    refreshClaimCaptcha() {
      this.fetchClaimCaptcha()
    },
    refreshReqCaptcha() {
      this.fetchReqCaptcha()
    },
    
    // ========== 验证图形验证码 ==========
    async verifyCaptchaCode(key, code) {
      try {
        const res = await verifyCaptcha({ key, code })
        if (res.status === 1) {
          return res.data.token
        } else {
          throw new Error(res.msg || '验证码错误')
        }
      } catch (error) {
        throw error
      }
    },
    
    // ========== 发送短信验证码 ==========
    async sendSmsCode(userName, captchaToken) {
      try {
        const res = await getPhoneCode({ userName, captchaToken })
        return res
      } catch (error) {
        throw error
      }
    },
    
    // ========== 认领相关 ==========
    async handleClaimSendCode() {
      const phone = this.claimForm.userName
      if (!phone) {
        this.$message.error('请输入手机号码')
        return
      }
      if (!/^1[3-9]\d{9}$/.test(phone)) {
        this.$message.error('请输入正确的手机号码')
        return
      }
      if (!this.claimForm.captchaInput) {
        this.$message.error('请输入图形验证码')
        return
      }
      
      try {
        const token = await this.verifyCaptchaCode(
          this.claimCaptchaKey,
          this.claimForm.captchaInput
        )
        
        const result = await this.sendSmsCode(phone, token)
        if (result.status === 1) {
          this.$message.success('验证码发送成功')
          this.startClaimCountdown()
          this.claimCaptchaToken = token
        } else {
          this.$message.error(result.msg || '发送失败')
          this.fetchClaimCaptcha()
        }
      } catch (error) {
        this.$message.error(error.message || '验证失败，请重试')
        this.fetchClaimCaptcha()
      }
    },
    startClaimCountdown() {
      this.claimCodeCountdown = 60
      const timer = setInterval(() => {
        this.claimCodeCountdown--
        if (this.claimCodeCountdown <= 0) {
          clearInterval(timer)
        }
      }, 1000)
    },
    async submitClaim() {
      const form = this.claimForm
      if (!form.userName || !form.captchaInput || !form.userCode || 
          !form.companyName || !form.productName || !form.contactName) {
        this.$message.error('请填写完整信息')
        return
      }
      if (!/^1[3-9]\d{9}$/.test(form.userName)) {
        this.$message.error('请输入正确的手机号码')
        return
      }
      if (this.claimNameCheckResult !== true) {
        this.$message.error('请先点击"查询名称"验证产品是否已收录')
        return
      }
      
      try {
        const res = await submitClaim({
          fw_name: '认领申请',
          lx_userName: form.contactName,
          userName: form.userName,
          userCode: form.userCode,
          notes: `公司名称：${form.companyName}，网站名称：${form.productName}，职务：${form.position || '未填写'}`
        })
        if (res.status === 1) {
          this.$message.success('认领提交成功，我们将尽快审核！')
          this.closeClaimModal()
          this.claimForm.userName = ''
          this.claimForm.userCode = ''
          this.claimForm.companyName = ''
          this.claimForm.productName = ''
          this.claimForm.contactName = ''
          this.claimForm.position = ''
          this.claimForm.captchaInput = ''
          this.claimCodeCountdown = 0
          this.claimNameCheckResult = null
        } else {
          this.$message.error(res.msg || '提交失败，请重试')
        }
      } catch (error) {
        this.$message.error('网络错误，请稍后重试')
        console.error('提交认领失败:', error)
      }
    },
    
    // ========== 提交需求相关 ==========
    async handleReqSendCode() {
      const phone = this.reqForm.userName
      if (!phone) {
        this.$message.error('请输入手机号码')
        return
      }
      if (!/^1[3-9]\d{9}$/.test(phone)) {
        this.$message.error('请输入正确的手机号码')
        return
      }
      if (!this.reqForm.captchaInput) {
        this.$message.error('请输入图形验证码')
        return
      }
      
      try {
        const token = await this.verifyCaptchaCode(
          this.reqCaptchaKey,
          this.reqForm.captchaInput
        )
        
        const result = await this.sendSmsCode(phone, token)
        if (result.status === 1) {
          this.$message.success('验证码发送成功')
          this.startReqCountdown()
          this.reqCaptchaToken = token
        } else {
          this.$message.error(result.msg || '发送失败')
          this.fetchReqCaptcha()
        }
      } catch (error) {
        this.$message.error(error.message || '验证失败，请重试')
        this.fetchReqCaptcha()
      }
    },
    startReqCountdown() {
      this.reqCodeCountdown = 60
      const timer = setInterval(() => {
        this.reqCodeCountdown--
        if (this.reqCodeCountdown <= 0) {
          clearInterval(timer)
        }
      }, 1000)
    },
    async submitRequirement() {
      const form = this.reqForm
      if (!form.userName || !form.captchaInput || !form.userCode || 
          !form.lx_userName || !form.address || !form.ys_money ||
          !form.fw_name || !form.notes) {
        this.$message.error('请填写完整信息')
        return
      }
      if (!/^1[3-9]\d{9}$/.test(form.userName)) {
        this.$message.error('请输入正确的手机号码')
        return
      }
      if (form.notes.length < 10) {
        this.$message.error('需求描述不能少于10个字')
        return
      }
      
      try {
        const res = await webYuyueService({
          fw_name: form.fw_name,
          lx_userName: form.lx_userName,
          userName: form.userName,
          userCode: form.userCode,
          notes: form.notes,
          address: form.address,
          ys_money: form.ys_money
        })
        if (res.status === 1) {
          this.$message.success('需求提交成功，我们将尽快与您联系！')
          this.closeRequirementModal()
          this.reqForm.userName = ''
          this.reqForm.userCode = ''
          this.reqForm.lx_userName = ''
          this.reqForm.address = ''
          this.reqForm.ys_money = ''
          this.reqForm.fw_name = ''
          this.reqForm.notes = ''
          this.reqForm.captchaInput = ''
          this.reqCodeCountdown = 0
        } else {
          this.$message.error(res.msg || '提交失败，请重试')
        }
      } catch (error) {
        this.$message.error('网络错误，请稍后重试')
        console.error('提交需求失败:', error)
      }
    }
  },
  watch: {
    isMobile() {
      this.updateItemHeight()
    }
  }
}
</script>

<style lang="less" scoped>
:root {
  --primary: #3EA9F6;
  --primary-dark: #2A8ACF;
  --primary-light: #67C2FF;
  --secondary: #FF6F2C;
  --accent: #FFCB63;
  --text-dark: #2D3748;
  --text-light: #718096;
  --bg-light: #F7FAFC;
  --bg-white: #FFFFFF;
  --border-radius: 12px;
  --shadow-sm: 0 2px 4px rgba(0,0,0,0.05);
  --shadow-md: 0 4px 6px rgba(0,0,0,0.07);
  --shadow-lg: 0 10px 15px rgba(0,0,0,0.1);
  --transition: all 0.3s ease;
}

#app {
  min-height: 100vh;
  background: var(--bg-light);
}

.header-spacer {
  height: 81px;
  width: 100%;
  
  &.with-ad {
    height: 125px;
  }
  
  @media (max-width: 768px) {
    height: 70px;
    
    &.with-ad {
      height: 108px;
    }
  }
}

.modern-header {
  height: auto !important;
  min-height: 81px;
  background: linear-gradient(135deg, #1a365d 0%, #2d3748 100%);
  box-shadow: var(--shadow-md);
  border-bottom: 1px solid rgba(255,255,255,0.1);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  backdrop-filter: blur(10px);
  
  .ad-banner {
    background: linear-gradient(135deg, #e8f0fe 0%, #f0f4f8 100%);
    border-bottom: 1px solid rgba(0,0,0,0.05);
    position: relative;
    overflow: hidden;
    animation: slideDown 0.5s ease-out;
    
    .ad-scroll-container {
      overflow: hidden;
      height: 52px;
      
      .ad-scroll-wrapper {
        transition: margin-top 0.5s ease-in-out;
        
        .ad-item {
          height: 52px;
          width: 100%;
          cursor: pointer;
          
          .ad-content {
            max-width: 1200px;
            margin: 0 auto;
            padding: 8px 60px 8px 20px;
            display: flex;
            align-items: center;
            gap: 12px;
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            
            img {
              height: 36px;
              width: auto;
              max-width: 160px;
              object-fit: contain;
              border-radius: 6px;
              box-shadow: 0 1px 3px rgba(0,0,0,0.1);
            }
            
            .ad-text {
              display: flex;
              align-items: center;
              gap: 6px;
              color: #2c3e50;
              font-size: 13px;
              font-weight: 500;
              
              i {
                font-size: 14px;
                color: #e74c3c;
                animation: pulse 1.5s infinite;
              }
              
              span {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: 300px;
              }
            }
            
            .ad-type {
              background: linear-gradient(135deg, #ff6b35 0%, #f7931e 100%);
              padding: 2px 8px;
              border-radius: 12px;
              margin-left: 4px;
              flex-shrink: 0;
              
              span {
                color: white;
                font-size: 11px;
                font-weight: 600;
                white-space: nowrap;
              }
            }
          }
        }
      }
    }
    
    .ad-close {
      position: absolute;
      right: 20px;
      top: 50%;
      transform: translateY(-50%);
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(0,0,0,0.1);
      border-radius: 50%;
      cursor: pointer;
      transition: all 0.3s ease;
      z-index: 10;
      
      &:hover {
        background: rgba(0,0,0,0.2);
        transform: translateY(-50%) scale(1.1);
      }
      
      i {
        color: #666;
        font-size: 12px;
      }
    }
  }
  
  .header-content {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 81px;
    padding: 0 20px;
  }
  
  .logo-link {
    display: flex;
    align-items: center;
    text-decoration: none;
    transition: var(--transition);
    
    &:hover {
      transform: translateY(-2px);
    }
  }
  
  .logo-text {
    h1 {
      color: white;
      font-size: 28px;
      font-weight: 700;
      margin: 0;
      text-shadow: 0 2px 4px rgba(0,0,0,0.1);
      line-height: 1.2;
    }
    
    .site-subtitle {
      color: rgba(255,255,255,0.9);
      font-size: 14px;
      margin: 2px 0 0 0;
      font-weight: 500;
    }
  }
  
  .navigation-tip {
    font-size: 14px;
    color: rgba(255,255,255,0.9);
    margin: 0;
  }
  
  .head-right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
  }
  
  .header-actions {
    display: flex;
    align-items: center;
    gap: 16px;
  }
  
  .header-enter-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 20px;
    background: linear-gradient(135deg, #f6d365 0%, #fda085 100%);
    color: #1a365d;
    border-radius: 25px;
    font-weight: 600;
    font-size: 14px;
    text-decoration: none;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(253, 160, 133, 0.4);
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 25px rgba(253, 160, 133, 0.6);
      color: #1a365d;
    }
    
    i {
      font-size: 16px;
    }
  }
  
  .stats-group {
    display: flex;
    align-items: center;
    gap: 10px;
    color: rgba(255,255,255,0.85);
    font-size: 13px;
    
    .stats-item {
      display: flex;
      align-items: center;
      gap: 4px;
      
      i {
        font-size: 13px;
        color: #48bb78;
      }
      
      strong {
        color: var(--accent);
        font-weight: 700;
        font-size: 15px;
      }
    }
    
    .stats-divider {
      color: rgba(255,255,255,0.2);
    }
  }
  
  .stats {
    color: white;
    font-size: 13px;
    margin: 0;
    text-align: right;
  }
  
  .highlight {
    color: var(--accent);
    font-weight: bold;
    font-size: 15px;
    margin: 0 4px;
  }
}

.modern-main {
  padding: 0;
  min-height: calc(100vh - 180px);
}

/* ===== 页脚样式 ===== */
.modern-footer {
  background: linear-gradient(135deg, #1a365d 0%, #2d3748 100%);
  color: white;
  padding: 0;
  height: auto !important;
  
  .footer-content {
    max-width: 1200px;
    margin: 0 auto;
    padding: 40px 20px 20px;
  }
  
  .footer-section {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 30px;
    
    @media (max-width: 768px) {
      flex-direction: column;
      gap: 30px;
    }
  }
  
  .footer-links {
    flex: 1;
    
    .section-title {
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 15px;
      color: white;
    }
    
    .link-group {
      display: flex;
      flex-direction: column;
      gap: 8px;
      
      a {
        color: rgba(255,255,255,0.9);
        text-decoration: none;
        transition: var(--transition);
        font-size: 14px;
        
        &:hover {
          color: var(--accent);
          transform: translateX(5px);
        }
      }
    }
  }
  
  .footer-actions {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 16px;
    
    @media (max-width: 768px) {
      grid-template-columns: repeat(5, 1fr);
      gap: 12px;
    }
    
    @media (max-width: 480px) {
      grid-template-columns: repeat(5, 1fr);
      gap: 8px;
    }
  }
  
  .action-card {
    text-align: center;
    
    .action-link {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-decoration: none;
      color: white;
      transition: var(--transition);
      cursor: pointer;
      
      &:hover {
        transform: translateY(-5px);
        
        .action-icon {
          background: rgba(255,255,255,0.2);
          transform: scale(1.1);
        }
      }
    }
    
    .action-icon {
      width: 56px;
      height: 56px;
      background: rgba(255,255,255,0.1);
      border-radius: var(--border-radius);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 6px;
      transition: var(--transition);
      backdrop-filter: blur(10px);
      
      img {
        width: 32px;
        height: 32px;
      }
    }
    
    span {
      font-size: 13px;
      font-weight: 500;
      color: white;
    }
  }
  
  .footer-bottom {
    border-top: 1px solid rgba(255,255,255,0.2);
    padding-top: 20px;
    text-align: center;
  }
  
  .footer-trust {
    display: flex;
    justify-content: center;
    gap: 30px;
    margin-bottom: 16px;
    
    .trust-item {
      font-size: 13px;
      color: rgba(255,255,255,0.8);
      
      i {
        margin-right: 4px;
        color: #48bb78;
      }
      
      strong {
        color: #f6d365;
        font-weight: 700;
      }
    }
    
    @media (max-width: 768px) {
      gap: 16px;
      flex-wrap: wrap;
      
      .trust-item {
        font-size: 12px;
      }
    }
  }
  
  .copyright {
    margin: 0 0 12px 0;
    color: rgba(255,255,255,0.9);
    font-size: 14px;
    
    a {
      color: var(--accent);
      text-decoration: none;
      
      &:hover {
        color: white;
        text-decoration: underline;
      }
    }
  }
  
  .police-badge {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    
    .police-icon {
      width: 20px;
      height: 20px;
      vertical-align: middle;
    }
    
    a {
      color: rgba(255,255,255,0.8);
      text-decoration: none;
      font-size: 12px;
      transition: var(--transition);
      
      &:hover {
        color: var(--accent);
        text-decoration: underline;
      }
    }
  }
}

/* ===== 右侧固定悬浮按钮 - 统一尺寸（缩小40%） ===== */
.floating-requirement-btn,
.floating-order-btn {
  position: fixed;
  right: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  padding: 8px 8px;
  color: white;
  border-radius: 12px;
  text-decoration: none;
  cursor: pointer;
  z-index: 999;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  min-width: 44px;
  min-height: 50px;
  border: none;
  box-shadow: 0 3px 15px rgba(0, 0, 0, 0.2);
}

.floating-requirement-btn {
  bottom: 200px;
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  box-shadow: 0 3px 15px rgba(245, 87, 108, 0.35);
  animation: floatPulsePink 3s ease-in-out infinite;
}

.floating-requirement-btn:hover {
  transform: translateY(-3px) scale(1.05);
  box-shadow: 0 6px 25px rgba(245, 87, 108, 0.5);
}

.floating-order-btn {
  bottom: 140px;
  background: linear-gradient(135deg, #07C160 0%, #06AD56 100%);
  box-shadow: 0 3px 15px rgba(7, 193, 96, 0.35);
  animation: floatPulseGreen 3s ease-in-out infinite;
}

.floating-order-btn:hover {
  transform: translateY(-3px) scale(1.05);
  box-shadow: 0 6px 25px rgba(7, 193, 96, 0.5);
}

.floating-requirement-btn:active,
.floating-order-btn:active {
  transform: scale(0.95);
}

.floating-requirement-btn .floating-icon svg,
.floating-order-btn .floating-icon svg {
  width: 18px;
  height: 18px;
  display: block;
  flex-shrink: 0;
}

.floating-requirement-btn .floating-text,
.floating-order-btn .floating-text {
  font-size: 9px;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-align: center;
  line-height: 1.1;
}

@keyframes floatPulsePink {
  0%, 100% {
    box-shadow: 0 3px 15px rgba(245, 87, 108, 0.35);
  }
  50% {
    box-shadow: 0 5px 25px rgba(245, 87, 108, 0.55);
  }
}

@keyframes floatPulseGreen {
  0%, 100% {
    box-shadow: 0 3px 15px rgba(7, 193, 96, 0.35);
  }
  50% {
    box-shadow: 0 5px 25px rgba(7, 193, 96, 0.55);
  }
}

/* ===== 弹窗通用样式 ===== */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  animation: fadeIn 0.3s ease;
  padding: 20px;
  box-sizing: border-box;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.modal-content {
  background: white;
  border-radius: 16px;
  padding: 40px;
  width: auto;
  max-width: 700px;
  min-width: 300px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.3s ease;
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .modal-content {
    padding: 24px 20px;
    max-width: 94%;
    min-width: unset;
    width: 94%;
    margin: 0 auto;
  }
}

@media (max-width: 480px) {
  .modal-content {
    padding: 20px 16px;
    max-width: 96%;
    width: 96%;
    margin: 0 auto;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.modal-title {
  font-size: 24px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0;
}

.modal-close {
  background: none;
  border: none;
  font-size: 30px;
  color: #9ca3af;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  transition: color 0.3s;
}

.modal-close:hover {
  color: #4b5563;
}

.modal-desc {
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 24px;
}

/* ===== 认领福利 ===== */
.claim-benefit {
  display: flex;
  align-items: center;
  gap: 10px;
  background: linear-gradient(135deg, #fff8e1 0%, #ffecb3 100%);
  border: 1px solid #ffd54f;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 20px;
}

.benefit-icon {
  font-size: 22px;
  flex-shrink: 0;
}

.benefit-text {
  font-size: 15px;
  color: #5d4037;
  line-height: 1.5;
}

.benefit-text strong {
  color: #e65100;
  font-weight: 700;
}

@media (max-width: 768px) {
  .claim-benefit {
    padding: 10px 12px;
  }
  .benefit-text {
    font-size: 13px;
  }
  .benefit-icon {
    font-size: 18px;
  }
}

/* ===== 平台微信引导（提交需求弹窗内） ===== */
.platform-wechat-guide {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
  border: 1px solid #86efac;
  border-radius: 10px;
  padding: 14px 16px;
  margin-bottom: 20px;
  
  .guide-icon {
    font-size: 28px;
    flex-shrink: 0;
    line-height: 1;
  }
  
  .guide-content {
    flex: 1;
    min-width: 0;
  }
  
  .guide-title {
    font-size: 14px;
    font-weight: 600;
    color: #1a365d;
    display: block;
    margin-bottom: 6px;
  }
  
  .guide-wechat {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
  }
  
  .guide-label {
    font-size: 13px;
    color: #6b7280;
  }
  
  .guide-number {
    font-size: 18px;
    font-weight: 700;
    color: #07C160;
    cursor: pointer;
    user-select: all;
    transition: color 0.3s;
    
    &:hover {
      color: #06AD56;
    }
  }
  
  .guide-copy-btn {
    display: flex;
    align-items: center;
    gap: 3px;
    padding: 3px 10px;
    background: #07C160;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 12px;
    cursor: pointer;
    transition: all 0.3s ease;
    
    &:hover {
      background: #06AD56;
      transform: scale(1.05);
    }
    
    i {
      font-size: 13px;
    }
  }
}

@media (max-width: 768px) {
  .platform-wechat-guide {
    padding: 12px 14px;
    
    .guide-icon {
      font-size: 22px;
    }
    
    .guide-title {
      font-size: 13px;
    }
    
    .guide-number {
      font-size: 16px;
    }
    
    .guide-copy-btn {
      font-size: 11px;
      padding: 2px 8px;
    }
  }
}

@media (max-width: 480px) {
  .platform-wechat-guide {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
    
    .guide-icon {
      font-size: 24px;
      text-align: center;
    }
    
    .guide-wechat {
      justify-content: center;
    }
  }
}

.modal-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.required {
  color: #ef4444;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 6px;
}

.form-input {
  width: 100%;
  padding: 12px 14px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: white;
  font-size: 15px;
  transition: border-color 0.3s, box-shadow 0.3s;
}

.form-input:focus {
  outline: none;
  border-color: #F58019;
  box-shadow: 0 0 0 3px rgba(245, 128, 25, 0.1);
}

.form-input.textarea {
  resize: vertical;
  min-height: 100px;
  font-family: inherit;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

@media (max-width: 768px) {
  .form-row {
    grid-template-columns: 1fr;
  }
}

.code-input-group {
  display: flex;
  gap: 10px;
}

.code-input {
  flex: 1;
}

.code-btn {
  padding: 0 16px;
  background: #F58019;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.3s;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 500;
}

.code-btn:hover:not(:disabled) {
  background: #e06d0f;
}

.code-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.captcha-input-group {
  display: flex;
  gap: 10px;
  align-items: center;
}

.captcha-input-group .form-input {
  flex: 1;
}

.captcha-image {
  flex-shrink: 0;
  height: 44px;
  width: 130px;
  cursor: pointer;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f9fafb;
  transition: opacity 0.3s;
  overflow: hidden;
}

.captcha-image:hover {
  opacity: 0.8;
}

.captcha-image svg {
  width: 100%;
  height: 100%;
}

.char-count {
  text-align: right;
  font-size: 13px;
  color: #9ca3af;
  margin-top: 4px;
}

.form-submit {
  margin-top: 8px;
}

.submit-btn {
  width: 100%;
  padding: 14px;
  background: linear-gradient(135deg, #FCC605 0%, #F58019 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.submit-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(245, 128, 25, 0.4);
}

.submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none !important;
}

/* ===== 输入框带操作按钮 ===== */
.input-with-action {
  display: flex;
  gap: 10px;
  align-items: center;
  width: 100%;
}

.input-with-action .input-container {
  flex: 1;
}

.input-with-action .form-input {
  width: 100%;
}

.check-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 12px 16px;
  background: linear-gradient(135deg, #48bb78 0%, #38a169 100%);
  border: none;
  border-radius: 8px;
  color: white;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(72, 187, 120, 0.3);
  flex-shrink: 0;
  height: 44px;
}

.check-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(72, 187, 120, 0.4);
}

.check-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none !important;
}

.check-btn i {
  font-size: 14px;
}

.name-check-result {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 500;
  padding: 6px 10px;
  border-radius: 6px;
  margin-top: 6px;
}

.name-check-result.success {
  color: #38a169;
  background: #f0fff4;
  border: 1px solid #68d391;
}

.name-check-result.error {
  color: #e53e3e;
  background: #fff5f5;
  border: 1px solid #fc8181;
}

.name-check-result i {
  font-size: 16px;
}

/* ===== 广告合作弹窗 ===== */
.ad-cooperation-content {
  max-width: 500px;
  text-align: center;
}

.ad-cooperation-body {
  padding: 20px 0 10px;
}

.ad-cooperation-icon {
  margin-bottom: 20px;
}

.ad-cooperation-icon svg {
  width: 80px;
  height: 80px;
}

.ad-cooperation-title {
  font-size: 24px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 12px;
}

.ad-cooperation-desc {
  font-size: 16px;
  color: #6b7280;
  line-height: 1.8;
  margin-bottom: 30px;
}

.ad-cooperation-btn {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 14px 36px;
  background: linear-gradient(135deg, #07C160 0%, #06AD56 100%);
  color: white;
  border: none;
  border-radius: 50px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 4px 20px rgba(7, 193, 96, 0.4);
}

.ad-cooperation-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 35px rgba(7, 193, 96, 0.5);
}

.ad-cooperation-btn svg {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.ad-cooperation-tip {
  font-size: 13px;
  color: #9ca3af;
  margin-top: 16px;
}

/* ===== 热门推荐弹窗 ===== */
.hot-modal {
  max-width: 520px;
  text-align: center;
}

.hot-body {
  padding: 10px 0;
}

.hot-icon {
  font-size: 56px;
  margin-bottom: 16px;
}

.hot-title {
  font-size: 22px;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 24px;
}

.hot-features {
  text-align: left;
  margin-bottom: 30px;
  
  .hot-feature {
    display: flex;
    gap: 14px;
    padding: 14px 16px;
    background: #f8fafc;
    border-radius: 10px;
    margin-bottom: 10px;
    transition: all 0.3s ease;
    
    &:hover {
      background: #edf2f7;
      transform: translateX(4px);
    }
    
    .hot-feature-icon {
      font-size: 24px;
      flex-shrink: 0;
    }
    
    strong {
      display: block;
      color: #1a365d;
      font-size: 15px;
    }
    
    p {
      margin: 4px 0 0;
      font-size: 13px;
      color: #718096;
    }
  }
}

.hot-contact-btn {
  display: inline-block;
  padding: 14px 48px;
  background: linear-gradient(135deg, #f6d365 0%, #fda085 100%);
  color: #1a365d;
  border-radius: 50px;
  font-size: 18px;
  font-weight: 700;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 4px 20px rgba(253, 160, 133, 0.4);
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 35px rgba(253, 160, 133, 0.6);
    color: #1a365d;
  }
}

.hot-tip {
  font-size: 13px;
  color: #9ca3af;
  margin-top: 14px;
}

/* ===== 我要接单弹窗 ===== */
.order-modal {
  max-width: 480px;
  text-align: center;
}

.order-body {
  padding: 10px 0;
}

.order-icon {
  font-size: 56px;
  margin-bottom: 12px;
}

.order-title {
  font-size: 22px;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 8px;
}

.order-desc {
  font-size: 15px;
  color: #4a5568;
  margin-bottom: 20px;
  line-height: 1.8;
  
  strong {
    color: #1a365d;
    font-weight: 700;
  }
}

.order-wechat {
  background: #f0fdf4;
  border: 2px solid #86efac;
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 18px;
  text-align: left;
}

.wechat-label {
  font-size: 13px;
  color: #6b7280;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.wechat-label i {
  font-size: 16px;
  color: #07C160;
}

.wechat-number {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.wechat-number span {
  font-size: 22px;
  font-weight: 700;
  color: #1a365d;
  letter-spacing: 2px;
  user-select: all;
  cursor: pointer;
}

.copy-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 14px;
  background: #07C160;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.copy-btn:hover {
  background: #06AD56;
  transform: scale(1.05);
}

.copy-btn i {
  font-size: 14px;
}

.wechat-tip {
  font-size: 12px;
  color: #6b7280;
  margin-top: 8px;
}

/* ===== 备注说明区域 ===== */
.order-remark {
  background: #f8fafc;
  border-radius: 10px;
  padding: 14px 16px;
  text-align: left;
}

.remark-title {
  font-size: 13px;
  font-weight: 600;
  color: #1a365d;
  margin: 0 0 10px 0;
}

.remark-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 10px;
  border-radius: 6px;
  margin-bottom: 6px;
  
  &:last-child {
    margin-bottom: 0;
  }
  
  .remark-tag {
    font-size: 12px;
    font-weight: 700;
    padding: 2px 10px;
    border-radius: 12px;
    flex-shrink: 0;
    min-width: 32px;
    text-align: center;
  }
  
  .remark-example {
    font-size: 13px;
    color: #4a5568;
  }
  
  .remark-demo {
    font-size: 12px;
    color: #9ca3af;
    margin-left: auto;
    flex-shrink: 0;
  }
}

.remark-item.personal {
  background: #eff6ff;
  
  .remark-tag {
    background: #3b82f6;
    color: white;
  }
}

.remark-item.enterprise {
  background: #ecfdf5;
  
  .remark-tag {
    background: #10b981;
    color: white;
  }
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

/* ===== 响应式 ===== */
@media screen and (max-width: 768px) {
  .modern-header {
    min-height: 70px;
    
    .ad-banner .ad-scroll-container {
      height: 44px;
      
      .ad-scroll-wrapper .ad-item {
        height: 44px;
        
        .ad-content {
          padding: 6px 50px 6px 15px;
          
          img {
            height: 28px;
            max-width: 100px;
          }
          
          .ad-text {
            font-size: 11px;
            
            i {
              font-size: 11px;
            }
            
            span {
              max-width: 150px;
            }
          }
          
          .ad-type {
            padding: 1px 6px;
            
            span {
              font-size: 9px;
            }
          }
        }
      }
    }
    
    .header-content {
      height: 70px;
      padding: 0 12px;
    }
    
    .logo-text h1 {
      font-size: 18px;
    }
    
    .logo-text .site-subtitle {
      font-size: 10px;
      display: none;
    }
    
    .navigation-tip {
      display: none;
    }
    
    .head-right {
      flex: 1;
      min-width: 0;
      align-items: flex-end;
    }
    
    .header-actions {
      display: flex;
      align-items: center;
      gap: 6px;
      flex-wrap: nowrap;
      width: 100%;
      justify-content: flex-end;
    }
    
    .header-enter-btn {
      display: inline-flex;
      align-items: center;
      gap: 3px;
      padding: 4px 10px;
      font-size: 11px;
      border-radius: 14px;
      white-space: nowrap;
      flex-shrink: 0;
      box-shadow: 0 2px 10px rgba(253, 160, 133, 0.3);
      
      i {
        font-size: 11px;
        margin-right: 1px;
      }
    }
    
    .stats-group {
      display: flex;
      align-items: center;
      gap: 4px;
      font-size: 10px;
      white-space: nowrap;
      flex-shrink: 1;
      min-width: 0;
      overflow: hidden;
      
      .stats-item {
        display: flex;
        align-items: center;
        gap: 2px;
        
        i {
          font-size: 9px;
          display: none;
        }
        
        strong {
          font-size: 11px;
          font-weight: 700;
          color: var(--accent);
        }
      }
      
      .stats-divider {
        display: inline-block;
        color: rgba(255,255,255,0.2);
        margin: 0 2px;
      }
    }
  }
  
  .floating-requirement-btn,
  .floating-order-btn {
    right: 14px;
    padding: 6px 6px;
    min-width: 36px;
    min-height: 42px;
    border-radius: 10px;
  }
  
  .floating-requirement-btn {
    bottom: 165px;
  }
  
  .floating-order-btn {
    bottom: 115px;
  }
  
  .floating-requirement-btn .floating-icon svg,
  .floating-order-btn .floating-icon svg {
    width: 15px;
    height: 15px;
  }
  
  .floating-requirement-btn .floating-text,
  .floating-order-btn .floating-text {
    font-size: 8px;
  }
  
  .footer-actions {
    grid-template-columns: repeat(5, 1fr) !important;
  }
  
  .action-icon {
    width: 44px !important;
    height: 44px !important;
  }
  
  .action-icon img {
    width: 24px !important;
    height: 24px !important;
  }
  
  .action-card span {
    font-size: 11px !important;
  }
  
  .ad-cooperation-btn {
    padding: 12px 24px;
    font-size: 16px;
  }
  
  .ad-cooperation-btn svg {
    width: 20px;
    height: 20px;
  }
  
  .input-with-action {
    flex-direction: column;
    gap: 8px;
  }
  
  .check-btn {
    width: 100%;
    justify-content: center;
  }
  
  .order-modal {
    max-width: 94%;
  }
  
  .wechat-number span {
    font-size: 18px;
  }
  
  .remark-item {
    flex-wrap: wrap;
    gap: 4px;
    
    .remark-demo {
      margin-left: 0;
      width: 100%;
      padding-left: 42px;
    }
  }
}

@media screen and (max-width: 480px) {
  .modern-header {
    .header-content {
      padding: 0 8px;
    }
    
    .logo-text h1 {
      font-size: 16px;
    }
    
    .header-actions {
      gap: 4px;
    }
    
    .header-enter-btn {
      padding: 3px 8px;
      font-size: 10px;
      border-radius: 12px;
      
      i {
        font-size: 10px;
        margin-right: 0;
      }
    }
    
    .stats-group {
      font-size: 9px;
      gap: 2px;
      
      .stats-item {
        strong {
          font-size: 10px;
        }
      }
      
      .stats-divider {
        display: none;
      }
    }
  }
  
  .modern-header .ad-banner .ad-content .ad-text span {
    max-width: 100px;
  }
  
  .modern-header .ad-banner .ad-content .ad-type {
    display: none;
  }
  
  .logo-text h1 {
    font-size: 18px;
  }
  
  .footer-actions {
    grid-template-columns: repeat(5, 1fr) !important;
    gap: 6px !important;
  }
  
  .action-icon {
    width: 38px !important;
    height: 38px !important;
  }
  
  .action-icon img {
    width: 20px !important;
    height: 20px !important;
  }
  
  .action-card span {
    font-size: 10px !important;
  }
  
  .ad-cooperation-btn {
    padding: 10px 18px;
    font-size: 14px;
  }
  
  .ad-cooperation-btn svg {
    width: 18px;
    height: 18px;
  }
  
  .ad-cooperation-title {
    font-size: 20px;
  }
  
  .floating-requirement-btn,
  .floating-order-btn {
    right: 10px;
    padding: 5px 5px;
    min-width: 32px;
    min-height: 36px;
    border-radius: 8px;
  }
  
  .floating-requirement-btn {
    bottom: 150px;
  }
  
  .floating-order-btn {
    bottom: 105px;
  }
  
  .floating-requirement-btn .floating-icon svg,
  .floating-order-btn .floating-icon svg {
    width: 13px;
    height: 13px;
  }
  
  .floating-requirement-btn .floating-text,
  .floating-order-btn .floating-text {
    font-size: 7px;
  }
  
  .wechat-number {
    flex-wrap: wrap;
    justify-content: center;
  }
  
  .wechat-number span {
    font-size: 20px;
  }
  
  .remark-item {
    .remark-example {
      font-size: 12px;
    }
    
    .remark-demo {
      font-size: 11px;
      padding-left: 36px;
    }
  }
}
</style>